import React, { useEffect, useState } from 'react';
import HeroSection from '../components/HeroSection';


type ResearchEntry = {
  title: string;
  link: string;
  image: string;
  tags: string[];
};

type ResearchContent = {
  heroSection: {
    backgroundImage: string;
    headingText: string;
    subHeadingText: string;
    heightSize: "small" | "medium" | "large";
    profileImage: string | null;
  };
  intro: {
    title: string;
    paragraph: string;
  };
  entries: ResearchEntry[];
};


const Research: React.FC = () => {
  const [content, setContent] = useState<ResearchContent | null>(null);

  useEffect(() => {
    fetch('/content/Research.json')
      .then((res) => res.json())
      .then(setContent)
      .catch(console.error);
  }, []);

  if (!content) return (
            <div className="flex items-center justify-center min-h-[50vh]">
                <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-logoPurple" />
            </div>
        );

  const { heroSection, intro, entries } = content;

  return (
    <div>
      <HeroSection {...heroSection} />

      <div className="p-8">
        <h1 className="text-4xl font-bold text-logoPurple text-center mb-4">
          {intro.title}
        </h1>

        <p className="max-w-3xl mx-auto text-gray-600 text-center mb-12">
          {intro.paragraph}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {entries.map((entry, idx) => (
            <a
              key={idx}
              href={entry.link}
              target={entry.link.startsWith('http') ? '_blank' : undefined}
              rel="noopener noreferrer"
              className="block hover:scale-[1.02] transition"
            >
              <div className="rounded-lg shadow-lg overflow-hidden bg-page h-full flex flex-col">
                <img
                  src={entry.image}
                  alt={entry.title}
                  className="w-full h-48 object-cover"
                />

                <div className="p-6 flex flex-col flex-grow">
                  <h2 className="text-xl font-bold text-logoPurple">
                    {entry.title}
                  </h2>

                  <div className="mt-auto pt-4">
                    {entry.tags.map((tag, i) => (
                      <span
                        key={i}
                        className="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2"
                      >
                        #{tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Research;
